export default __webpack_public_path__ + "static/media/easter-egg-red.6f27d796.svg";